
import { defineComponent, SetupContext } from "vue";
import SearchTagItem from "./SearchTagItem.vue";
import { getRefinedTagName } from "@/utils/search-util";

export default defineComponent({
  name: "SearchRefinedTagList",
  components: { SearchTagItem },
  props: {
    /**
     * タグを表示するデータ配列
     */
    tags: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    /**
     * レシピ押下時に id と type を通知する
     *
     * @param {number} id - レシピID
     * @param {string} type - レシピの種別
     */
    const selectRecipe = (id: number, type: string) => {
      context.emit("on-click", id, type);
    };

    /**
     * タグ押下時に type と tag を通知する
     *
     * @param {string} alias - タググループ種別
     * @param {number} id - タグId
     */
    const selectTag = (alias: string, id: number) => {
      context.emit("select-tag", alias, id);
    };

    return {
      selectRecipe,
      selectTag,
      getRefinedTagName
    };
  }
});
